import * as React from 'react';
import { createSvg } from '../../utils/createSvg';
export var CheckSmall = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M6.568 13a.748.748 0 0 1-.525-.214l-3.819-3.75a.749.749 0 1 1 1.051-1.07l3.257 3.198 6.158-6.912a.749.749 0 1 1 1.12.998l-6.682 7.5a.753.753 0 0 1-.535.25h-.025" })), '0 0 16 16', 'CheckSmall');
//# sourceMappingURL=CheckSmall.js.map